module.exports = __webpack_public_path__ + "img/icon-issue.0073ec1.svg";